import { useEffect } from 'react'

const SCRIPT_ID = 'meta-pixel-base'

/**
 * Injects the official Meta Pixel base code once and tracks a PageView.
 * Wrapped defensively so a blocked or failing pixel never breaks the page.
 */
export function useMetaPixel(pixelId: string): void {
  useEffect(() => {
    try {
      if (typeof window === 'undefined') return
      if (document.getElementById(SCRIPT_ID)) return

      const script = document.createElement('script')
      script.id = SCRIPT_ID
      script.text = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${pixelId}');
fbq('track', 'PageView');
`
      document.head.appendChild(script)
    } catch (error) {
      console.warn('Meta Pixel could not be loaded', error)
    }
  }, [pixelId])
}
